import type { JSX } from 'react';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageFooter } from '../components/PageFooter';
import { PageMeta } from '../components/PageMeta';
import { PageState } from '../components/PageState';

import { usePullBandits } from './hooks/usePullBandits';
import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();
	usePullBandits();

	return (
		<>
			{/* PageBanner on desktop only - on mobile it's inside parallax */}
			<div className="relative hidden md:block">
				<PageBanner />
			</div>

			<div className="bg-background-overlay min-h-screen w-full pb-16 md:pt-[50px]">
				<PageMeta />
				<PageState />
				<PageBody />
				<PageFooter />
			</div>
		</>
	);
}
